import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { composeMiddleware } from "@/store2/middleware";
import { StoreGet, StoreSet } from "@/types";

import { commonActions } from "@/store2/common";
import { ActivityTypeCode, CouponTypeCode } from "project-config/constants";
import { payWithAli } from "@/components/top-up/help/payWithAli";
import { handlePaycode } from "@/utils";
import {
  IAnimationTopUpAction,
  IAnimationTopUpState,
  IAnimationTopUpStore,
  IVerifyRechargeCodeParams,
} from "../types";
import { AnimationTopUpAPI } from "./service";
import { useZustandDevtool } from "project-config/utils";
import { BindActivityInfo } from "@/components/top-up/types";

const defaultDesktopActivity = () => ({
  id: -1,
  activityName: "云制作币充值",
  activityNameEn: "Recharge of Cloud Production Coins",
  startDate: 1734315979000,
  endDate: 9760083093043,
  status: 1,
  partInTime: null,
  buriedPointId: null,
  pictureUrl: null,
  jumpUrl: null,
  rulesCn:
    "一、充值规则\n1、充值金额与云制作币为1:1兑换\n2、如有其他充值问题，请联系在线客服\n二、充值金额：1～200000\n三、展示当前账号云制作币余额与云制作币累积充值金额",
  rulesEn:
    "1. Recharge Rules\n1. The exchange ratio between the recharge amount and Cloud Production Coins is 1:1.\n2. For other recharge-related issues, please contact online customer service.\n2. Recharge Amount: 1～200000\n3. Display the current account's Cloud Production Coin balance and the cumulative recharge amount of Cloud Production Coins.",
  presentType: 0,
  rechargeType: null,
  remark: "",
  activityAdType: 0,
  imageUrlLink: "",
  imageUrlLinkEventDetails: "",
  chineseSlogan: "",
  englishSlogan: "",
  activityType: 4,
  giftType: -1,
  darkImageUrl: "",
  lightImageUrl: "",
  pictureImageUrlLink: "",
  maxCouponAmount: null,
  activityDetail: [
    {
      id: 1,
      activityTemplateId: 1,
      vipAmount: null,
      vipPresentAmount: null,
      amount: 1000,
      couponType: CouponTypeCode.Desktop,
      presentAmount: 1000,
      level: null,
      lotteryCount: null,
      surveyLotteryCount: null,
      createDate: 1734316418000,
      updateDate: 1734316418000,
      prizeType: null,
      prizeName: null,
      prizeCount: null,
      iconWord: null,
      isSendVoucher: 1,
    },
    {
      id: 2,
      activityTemplateId: 2,
      vipAmount: null,
      vipPresentAmount: null,
      amount: 5000,
      couponType: CouponTypeCode.Desktop,
      presentAmount: 5000,
      level: null,
      lotteryCount: null,
      surveyLotteryCount: null,
      createDate: 1734316418000,
      updateDate: 1734316418000,
      prizeType: null,
      prizeName: null,
      prizeCount: null,
      iconWord: null,
      isSendVoucher: 1,
    },
    {
      id: 3,
      activityTemplateId: 3,
      vipAmount: null,
      vipPresentAmount: null,
      amount: 10000,
      couponType: CouponTypeCode.Desktop,
      presentAmount: 10000,
      level: null,
      lotteryCount: null,
      surveyLotteryCount: null,
      createDate: 1734316418000,
      updateDate: 1734316418000,
      prizeType: null,
      prizeName: null,
      prizeCount: null,
      iconWord: null,
      isSendVoucher: 1,
    },
    {
      id: 4,
      activityTemplateId: 4,
      vipAmount: null,
      vipPresentAmount: null,
      amount: 20000,
      couponType: CouponTypeCode.Desktop,
      presentAmount: 20000,
      level: null,
      lotteryCount: null,
      surveyLotteryCount: null,
      createDate: 1734316418000,
      updateDate: 1734316418000,
      prizeType: null,
      prizeName: null,
      prizeCount: null,
      iconWord: "",
      isSendVoucher: 1,
    },
  ],
});

export const initVerifyRechargeInfo = {
  activityId: 0,
  couponAmount: 0,
  couponNO: "",
  rechargeAmount: 0,
  couponType: CouponTypeCode.Universal,
};

const initialState = (): IAnimationTopUpState => {
  return {
    activeName: "",
    rechargeSecondActiveName: "", // 充值tab的二级tab
    activityInfoList: [], // 除抽奖活动外的活动
    luckDrawGiftActivityInfo: null, // 抽奖活动
    lotteryActivityInfoList: [], // 抽奖券信息
    HangTags: [], // 常规充值
    discountName: "discount", // 常规充值-到达vip等级渲染消费折扣
    checkedRadioId: 0,
    amount: 0,
    inputAmount: "",
    cpuQingCloudAmount: null,
    desktopAmount: null,
    hasScanned: false,
    vipMemberType: null,
    paying: false,
    isCheckCard: true,
    showCouponCodeModal: false,
    inputCode: "",
    verifyRechargeInfo: initVerifyRechargeInfo,
  };
};

const getter = (get: StoreGet<IAnimationTopUpStore>) => ({
  // 是否存在充值赠送券活动
  haveRechargeGiftCouponActivity: () => {
    const { activityInfoList } = get();
    return activityInfoList.some(
      (item) => item.activityType === ActivityTypeCode.RechargeGift
    );
  },
  // 充值赠送券活动
  rechargeGiftCouponActivity: () => {
    const { activityInfoList, haveRechargeGiftCouponActivity } = get();
    if (haveRechargeGiftCouponActivity()) {
      const rechargeGiftActivity = activityInfoList.find(
        (item) => item.activityType === ActivityTypeCode.RechargeGift
      );
      const obj = rechargeGiftActivity?.activityDetail.reduce(
        (acc: any, curr) => {
          const key = curr.amount;
          const { amount, ...other } = curr;
          if (!key) return acc;
          if (!acc[key]) {
            acc[key] = {
              ...curr,
              detailList: [
                {
                  ...other,
                },
              ],
            };
          } else {
            acc[key].detailList.push({ ...other });
          }
          return acc;
        },
        {}
      );
      const newRechargeGiftActivity = {
        ...rechargeGiftActivity,
        activityDetail: Object.values(obj).map((group: any) => {
          const shouldKeepList = group.detailList.length > 1;
          return shouldKeepList
            ? group
            : (({ detailList, ...rest }) => rest)(group);
        }),
      };
      return newRechargeGiftActivity;
    } else {
      return {};
    }
  },
  // 是否存在青云活动
  haveQingCloudActivity: () => {
    const { activityInfoList } = get();
    return activityInfoList.some(
      (item) => item.activityType === ActivityTypeCode.QingCloudGift
    );
  },
  // 青云活动
  qingCloudActivity: () => {
    const { activityInfoList, haveQingCloudActivity } = get();
    if (haveQingCloudActivity()) {
      return activityInfoList.find(
        (item) => item.activityType === ActivityTypeCode.QingCloudGift
      );
    } else {
      return {};
    }
  },
  desktopActivity: () =>
    defaultDesktopActivity() as unknown as BindActivityInfo,
});

const actions = (
  set: StoreSet<IAnimationTopUpStore>,
  get: StoreGet<IAnimationTopUpStore>
): IAnimationTopUpAction => ({
  ...commonActions(set, get),
  addPayRecord: async (params: any) => {
    set((state) => {
      state.paying = true;
    });
    const { code, data } = await AnimationTopUpAPI.addPayRecord(params);
    if (code !== 200) {
      set((state) => {
        state.paying = false;
      });
      handlePaycode(code);
      return;
    }
    payWithAli(data.params, () => "todo modal");
    set((state) => {
      state.paying = false;
    });
  },
  verifyRechargeCode: async (params: IVerifyRechargeCodeParams) => {
    const res = await AnimationTopUpAPI.verifyRechargeCode(params);
    return res;
  },
});

export const useAnimationTopUpStore = create<IAnimationTopUpStore>()(
  composeMiddleware(
    [devtools, immer],
    (
      set: StoreSet<IAnimationTopUpStore>,
      get: StoreGet<IAnimationTopUpStore>
    ) => ({
      ...initialState(),
      ...actions(set, get),
      ...getter(get),
    })
  )
);

// eslint-disable-next-line react-hooks/rules-of-hooks
useZustandDevtool("AnimationTopUpStore", useAnimationTopUpStore);
